import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import API_BASE from "../utils/api";
import Modal from "./Modal";

const SCANNER_ELEMENT_ID = "attendance-qr-reader";

// Scans a classroom attendance-session QR code (generated by POST
// /attendance/qr-session) with the device camera, resolves it against the
// backend, and hands the resolved {classId, className, section, period,
// subject, date} back to the caller via onResolved. Camera lifecycle is
// entirely owned by the html5-qrcode library — it renders its own UI
// (camera picker, scan box) into the div referenced by SCANNER_ELEMENT_ID.
const QrScannerModal = ({ onClose, onResolved }) => {
  const scannerRef = useRef(null);
  const [error, setError] = useState("");
  const [resolving, setResolving] = useState(false);

  useEffect(() => {
    let cancelled = false;

    import("html5-qrcode").then(({ Html5QrcodeScanner }) => {
      if (cancelled) return;
      const scanner = new Html5QrcodeScanner(
        SCANNER_ELEMENT_ID,
        { fps: 10, qrbox: { width: 250, height: 250 } },
        false
      );
      scannerRef.current = scanner;

      scanner.render(
        async (decodedText) => {
          if (resolving) return;
          setResolving(true);
          try {
            const res = await axios.post(`${API_BASE}/attendance/qr-session/resolve`, { token: decodedText });
            await scanner.clear().catch(() => {});
            onResolved(res.data);
          } catch (err) {
            setError(err.response?.data?.error || "Failed to resolve this QR code");
            setResolving(false);
          }
        },
        () => {
          // Called continuously while no QR is in frame — ignore.
        }
      );
    });

    return () => {
      cancelled = true;
      scannerRef.current?.clear().catch(() => {});
    };
  }, []);

  return (
    <Modal title="Scan Class QR Code" subtitle="Point your camera at the classroom's attendance QR" onClose={onClose}>
      <div className="space-y-3">
        {error && <div className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">{error}</div>}
        {resolving && <p className="text-sm text-indigo-600">Resolving…</p>}
        <div id={SCANNER_ELEMENT_ID} className="w-full" />
      </div>
    </Modal>
  );
};

export default QrScannerModal;
